export enum ENTRY_STATES {
  NEW,
  MODIFIED
}
